import { BaseRepository } from "@/repositories/base-repository"
import { type ISaleItem } from "@/interfaces/api/sale-item.interface"

export class SaleItemRepository extends BaseRepository<ISaleItem> {
  protected resourcePath = "administration/sale-items"
}
